function getLocalFile(market: string, file: 'info' | 'content'): any {
  let data = {};
  try {
    data = require(`../../public/json/crypto/${market}/${file}.json`) || {};
  } catch (error) {
    // throw new Error("");
  }
  return data;
}

export default getLocalFile;
